import styled from "styled-components";
// import palette from "../../lib/styles/palette";

import React from "react";


const LanguageSelectionButtons = ({ language, onChangeLanguage }) => {

    return (
        <LanguageSelectionButtonsBlock>
            <form>
                <label>
                    <input type="radio" value="KR" checked={language === 'KR'} onChange={onChangeLanguage} />KR
                </label>
                <label>
                    <input type="radio" value="JP" checked={language === 'JP'} onChange={onChangeLanguage} />JP
                </label>
                <label>
                    <input type="radio" value="EN" checked={language === 'EN'} onChange={onChangeLanguage} />EN
                </label>
            </form>
        </LanguageSelectionButtonsBlock>
    );
};

export default LanguageSelectionButtons;


/* =================   Styles   ================== */
const LanguageSelectionButtonsBlock = styled.div`
    margin-right: 1rem;

    label {
        margin-right: 0.5rem;
    }
`;
